import changeCurrency from './components/changeCurrency'
import changeLanguage from './components/changeLanguage'
import productSearch from './components/productSearch'
import callbackForm from './components/callbackForm'
import {tns} from 'tiny-slider/src/tiny-slider'

if (document.getElementById('change-currency')) {
    new Vue({
        el: '#change-currency',
        components: {
            changeCurrency
        }
    })
}

if (document.getElementById('change-language')) {
    new Vue({
        el: '#change-language',
        components: {
            changeLanguage
        }
    })
}

if (document.getElementById('product-search')) {
    new Vue({
        el: '#product-search',
        components: {
            productSearch
        }
    })

    if (document.getElementById('mobile-product-search')) {
        new Vue({
            el: '#mobile-product-search',
            components: {
                productSearch
            }
        })
    }

    if (document.getElementById('show-header-search')) {
        let headerSearch = document.getElementById('header-search')
        let cartMenu = document.getElementById('cart-menu')

        document.getElementById('show-header-search').addEventListener('click', function () {
            if (headerSearch.classList.contains('open')) {
                headerSearch.classList.remove('open')
                document.body.classList.remove('dark-bg')
            } else {
                headerSearch.classList.add('open')
                document.body.classList.add('dark-bg')
                cartMenu.classList.remove('visible')
            }
        }, false)
    }

    if (document.getElementById('header-search_mob')) {
        let el = document.getElementById('header-menu')
        let burger = document.getElementById('burger-menu')

        document.getElementById('header-search_mob').addEventListener('click', function () {
            if (this.classList.contains('active')) {
                this.classList.remove('active')
                el.classList.remove('expand-search')
            } else {
                this.classList.add('active')
                el.classList.add('expand-search')
                el.classList.remove('expand')
                burger.classList.remove('active')
            }
        }, false)
    }
}

if (document.getElementById('callback-form')) {
    new Vue({
        el: '#callback-form',
        components: {
            callbackForm
        }
    })
}


document.addEventListener('DOMContentLoaded', function (e) {
    if (document.getElementById('sidebar-slider')) {
        let sidebarSlider = tns({
            container: '#sidebar-slider',
            items: 1,
            slideBy: 'page',
            navPosition: 'bottom',
            controls: false,
            onInit: function (inst) {
                inst.sheet.cssRules[1].style.opacity = '1'
            }
        })
    }

    if (document.getElementById('main-slider')) {
        let mainSlider = tns({
            container: '#main-slider',
            items: 1,
            slideBy: 'page',
            navPosition: 'bottom',
            controls: true,
            onInit: function (inst) {
                inst.sheet.cssRules[1].style.opacity = '1'
            }
        })
    }

    if (document.getElementById('product-slider')) {
        let productSlider = tns({
            container: '#product-slider',
            items: 1,
            slideBy: 'page',
            navPosition: 'bottom',
            controls: false,
            onInit: function (inst) {
                inst.sheet.cssRules[1].style.opacity = '1'
            }
        })
    }

    if (document.getElementById('main-product-slider')) {
        let mainProductSlider = tns({
            container: '#main-product-slider',
            items: 1,
            slideBy: 'page',
            navPosition: 'bottom',
            controls: true,
            onInit: function (inst) {
                inst.sheet.cssRules[1].style.opacity = '1'
            },
            responsive: {
                768: {
                    items: 3
                },
                1024: {
                    items: 4
                }
            }
        })
    }

    if (document.getElementById('info-slider') && window.innerWidth < 768) {
        let mainProductSlider = tns({
            container: '#info-slider',
            items: 1,
            slideBy: 'page',
            navPosition: 'bottom',
            controls: false,
            onInit: function (inst) {
                inst.sheet.cssRules[1].style.opacity = '1'
            },
            responsive: {
                480: {
                    items: 2
                },
                600: {
                    items: 3
                }
            }
        })
    }

    if (document.getElementById('recently-viewed-product-slider')) {
        let recentlyViewedProductSlider = tns({
            container: '#recently-viewed-product-slider',
            items: 1,
            slideBy: 'page',
            navPosition: 'bottom',
            controls: false
        })
    }
})


//sidebar accordion
if (document.getElementsByClassName('product-list')) {
    let elements = document.querySelectorAll('.product-list .opener')

    let sidebarAccordion = function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active')
            this.nextElementSibling.style.display = 'none'
        } else {
            this.classList.add('active')
            this.nextElementSibling.style.display = 'block'
        }
    }

    for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', sidebarAccordion, false)
    }
}

// FAQ page accordion
if (document.getElementsByClassName('faq__question')) {
    let elements = document.querySelectorAll('.faq__question')
    let answers = document.querySelectorAll('.faq__answer')

    let faqAccordion = function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active')
            this.nextElementSibling.style.display = 'none'
        } else {
            this.classList.add('active')
            this.nextElementSibling.style.display = 'block'
        }
    }

    for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', faqAccordion, false)

        elements[i].classList.add('active')
        answers[i].style.display = 'block'
    }

}

// product page shipping country icon
if (document.getElementsByClassName('js-iti-flag')) {
    let intervalId = setInterval(function () {
        let countryCode = localStorage.getItem('countryCode')

        if (countryCode) {
            let elements = document.querySelectorAll('.js-iti-flag')

            for (let i = 0; i < elements.length; i++) {
                if (countryCode) {
                    let countryClass = 'iti__' + countryCode.toLowerCase()
                    elements[i].classList.add(countryClass)
                } else {
                    elements[i].classList.add('iti__gb')
                }
            }
            clearInterval(intervalId)
        }
    }, 200)
}

if (document.getElementById('stock')) {
    let stockSlider = tns({
        container: '#stock',
        items: 1,
        slideBy: 'page',
        navPosition: 'bottom',
        controls: true,
        arrowKeys: true,
        autoplay: true,
        autoplayButtonOutput: false,
    })

    let el = document.getElementById('modal-backdrop')

    if (el) {
        document.getElementById('stock').addEventListener('click', function () {
            if (el.classList.contains('hide')) {
                el.classList.remove('hide')
                document.body.style.overflow = 'hidden'
            } else {
                el.classList.add('hide')
                document.body.removeAttribute('style')
            }
        }, false)

        el.addEventListener('click', function (event) {
            const modal = document.getElementById('free-pills-popup')
            let target = event.target

            do {
                if (modal === target) {
                    return
                }

                target = target.parentNode

            } while (target)

            closeModal(el)

        }, false)

        document.querySelector('.close-modal').addEventListener('click', function () {
            closeModal(el)
        }, false)
    }
}

if (document.getElementById('show-login-btn')) {
    document.getElementById('show-login-btn').addEventListener('click', function () {
        if (this.classList.contains('open')) {
            this.classList.remove('open')
        } else {
            this.classList.add('open')
        }
    }, false)
}

if (document.getElementById('burger-menu')) {
    let el = document.getElementById('header-menu')
    document.getElementById('burger-menu').addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active')
            el.classList.remove('expand')
        } else {
            this.classList.add('active')
            el.classList.add('expand')
        }
    }, false)
}

if (document.getElementById('burger-menu-3')) {
    let el = document.getElementById('header-main')
    document.getElementById('burger-menu-3').addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active')
            el.classList.remove('expand')
        } else {
            this.classList.add('active')
            el.classList.add('expand')
        }
    }, false)
}

if (document.getElementById('cart__ico_mob')) {
    let el = document.getElementById('header-main')
    document.getElementById('cart__ico_mob').addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active')
            el.classList.remove('expand-cart')
        } else {
            this.classList.add('active')
            el.classList.add('expand-cart')
        }
    }, false)
}


if (document.getElementById('show-text') && document.getElementById('hide-text')) {
    let hideTextEl = document.getElementById('show-text')
    let showTextEl = document.getElementById('hide-text')

    let elements = document.querySelectorAll('.item__subtitle_link.other_name.hide')

    hideTextEl.addEventListener('click', function () {
        this.classList.add('hide')
        showTextEl.classList.remove('hide')

        for (let i = 0; i < elements.length; i++) {
            elements[i].classList.remove('hide')
        }
    }, false)

    showTextEl.addEventListener('click', function () {
        this.classList.add('hide')
        hideTextEl.classList.remove('hide')

        for (let i = 0; i < elements.length; i++) {
            elements[i].classList.add('hide')
        }
    }, false)
}

if (document.getElementById('redirect-url')) {
    let seconds = 10

    let interval = setInterval(() => {
        if (seconds > 0) {
            seconds--
            if (seconds < 10) {
                seconds = '0' + seconds
            }
            document.getElementById('timer').textContent = seconds
        } else {
            clearInterval(interval)
            window.location = document.getElementById('redirect-url').href
        }
    }, 1000)
}


function closeModal(el) {
    if (!el.classList.contains('hide')) {
        el.classList.add('hide')
        document.body.removeAttribute('style')
    }
}
